import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    if (error?.message?.includes("MetaMask")) {
      // Ignore MetaMask errors completely
      return { hasError: false };
    }
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    if (error?.message?.includes("MetaMask")) {
      console.warn("⛔ Ignored MetaMask error:", error);
    } else {
      console.error("App Error:", error, errorInfo);
    }
  }
  render() {
    return this.props.children;
  }
}

// ✅ Render app
ReactDOM.render(
  <ErrorBoundary>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ErrorBoundary>,
  document.getElementById("root")
);
